"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./common/accordion-list");
require("./common/youtube-video");
require("./shop-common");
require("./page-smart-integrations/features");
var ProductFilterModule = require("./shop-archive/archive-filter-by-category");
var SupportManuals = require("./page-support/manuals");
var SetConfigurator = require("./page-product_info/set-configurator");
var UpsellSection = require("./page-product_info/custom-upsells");
var ProductGallery = require("./page-product_info/horizontal-slider-with-description");
var HeroProduct = require("./page-product_info/hero/");
var HeroPage = require("./page-home/hero");
var ConfiguratorTabs = require("./common/configurator-with-steps");
var Tabs = require("./common/tabs");
var MaimMenu = require("./site-layout/header");
var HeroPartners = require("./common/partners");
var AppFeature = require("./shared-sections/app-features");
var UpsellProduct = require("./page-product_info/custom-upsells");
var KeyFeatures = require("./page-product_info/strengths");
var VideoAutoplaySection = require("./shared-sections/two-columns");
var FeaturesSlider = require("./page-smart-integrations/features");
var BundleProducts = require("./shop-product");
var BlogScrollButton = require("./blog-archive");
var PressSlider = require("./page-press/partners-section");
var HowItWorks = require("./page-how-it-works/hero");
var VideoSlider = require("./page-how-it-works/video");
var SmartHeader = require("./page-smart-integrations/hero");
var ComingSoon = require("./page-how-it-works/coming_soon");
var CaseStudy = require("./page-how-it-works/case_studies");
var ClientReview = require("./page-how-it-works/clients_about_us");
var WorksWith = require("./page-how-it-works/specification");
var LookWhatCanIDo = require("./page-how-it-works/select");
new ProductGallery.default;
new SetConfigurator.default;
new HeroProduct.default;
new UpsellSection.default;
new ConfiguratorTabs.default;
new MaimMenu.default;
new HeroPartners.default;
new AppFeature.default;
new UpsellProduct.default;
new KeyFeatures.default;
new PressSlider.default;
BlogScrollButton.init();
HeroPage.init();
Tabs.init();
VideoAutoplaySection.init();
ProductFilterModule.init();
SupportManuals.init();
FeaturesSlider.init();
BundleProducts.init();
HowItWorks.init();
SmartHeader.init();
VideoSlider.init();
ComingSoon.init();
CaseStudy.init();
ClientReview.init();
WorksWith.init();
LookWhatCanIDo.init();
